import { IsDate, IsDefined, IsString } from 'class-validator';

export class ChatUserTokenDto {
  @IsDefined()
  @IsString()
  userId: string;

  @IsDefined()
  @IsString()
  userToken: string;

  @IsDefined()
  @IsDate()
  expDate: Date;
}
